import React from 'react';
import { useDatabaseRevisionsPage } from 'apps/sigma2-ui/src/data-wizard/lib/useDatabaseRevisionsPage';
import { AdminLayout } from 'apps/sigma2-ui/src/components/AdminLayout';
import { Table } from 'apps/sigma2-ui/src/components/ui/Table';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { getDateStringAsReadableString } from 'libs/end-to-end/src/dates';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { getDatabaseRevisionNameOrDefault } from 'libs/end-to-end/src/types/databases/revisions/database-revision';
import { Switch } from 'apps/sigma2-ui/src/components/ui/Switch';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { AdminBreadcrumbs } from 'apps/sigma2-ui/src/components/ui/AdminBreadcrumbs';

export const DatabaseRevisionsPage = () => {
  const language = useLanguage();

  const { organizationId, databaseId, navigate, revisions, database, onSave } =
    useDatabaseRevisionsPage();

  return (
    <AdminLayout currentPage={'DatabaseRevisions'}>
      <AdminBreadcrumbs
        items={[
          { label: 'Home', to: '/admin' },
          { label: 'Organizations', to: '/organizations' },
          {
            label: 'Databases',
            to: `/organizations/${organizationId}/databases`,
          },
          {
            label: 'Edit Database',
            to: `/organizations/${organizationId}/databases/edit/${databaseId}`,
          },
          {
            label: 'Revisions',
            to: `/organizations/${organizationId}/databases/${databaseId}/revisions`,
          },
        ]}
      />
      <S2Typography
        variant="headline-4"
        translatedContent={language.databaseRevisions()}
      />

      <S2Typography
        variant="headline-5"
        translatedContent={language.databaseNameOrNA({
          databaseName: database?.name,
        })}
      />
      <Table
        items={revisions?.databaseRevisions ?? []}
        columnDefinitions={[
          {
            id: 'name',
            header: () => <div>Name</div>,
            cell: ({ item }) => (
              <div>
                {getDatabaseRevisionNameOrDefault({
                  revision: item,
                  databaseName: database?.name ?? '',
                })}
              </div>
            ),
          },
          {
            id: 'status',
            header: () => <div>Status</div>,
            cell: ({ item }) => <div>{item.revisionStatus}</div>,
          },
          {
            id: 'sequence',
            header: () => <div>Sequence</div>,
            cell: ({ item }) => <div>{item.sequence}</div>,
          },
          {
            id: 'createdAt',
            header: () => <div>Created At</div>,
            cell: ({ item }) => (
              <div>
                {item.createdDate
                  ? getDateStringAsReadableString(item.createdDate)
                  : 'N/A'}
              </div>
            ),
          },
          {
            id: 'publishedAt',
            header: () => <div>Published At</div>,
            cell: ({ item }) => (
              <div>
                {item.publishDate
                  ? getDateStringAsReadableString(item.publishDate)
                  : 'N/A'}
              </div>
            ),
          },
          {
            id: 'isHidden',
            header: () => <div>Hidden</div>,
            cell: ({ item }) => {
              return (
                <div className="items-center">
                  <Switch
                    checked={item.isHidden ?? false}
                    onChange={() => {
                      onSave({
                        revisionId: item.id,
                        isHidden: !item.isHidden,
                      });
                    }}
                  />
                </div>
              );
            },
          },
          {
            id: 'actions',
            header: () => <div>Actions</div>,
            cell: ({ item }) => {
              return (
                <Button
                  behavior={{
                    type: 'onClick',
                    onClick: () => {
                      navigate(
                        `/organizations/${organizationId}/databases/${databaseId}/revisions/${item.id}/schema`,
                      );
                    },
                  }}
                  variant={'outline'}
                  size={'small'}
                >
                  <S2Typography
                    variant={'headline-7'}
                    translatedContent={language.edit()}
                  />
                </Button>
              );
            },
          },
        ]}
      ></Table>
    </AdminLayout>
  );
};
